//
//
//
//
//
//
//
//
//

export default {
  name: 'HomePage',
  data: () => ({
    description:
      'Get a high quality custom landing page or microsite built by professionals.',
  }),
  head() {
    return {
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
    };
  },
};
